<script setup lang="ts">
import PrimeDataView from "primevue/dataview";
import { watchEffect } from "vue";
import ReminderItem from "./ReminderItem.vue";
import type { RemindersProps } from "./types.ts";
import { useReminders } from "./useReminders.ts";

const props = defineProps<RemindersProps>();
const emit = defineEmits(["updateRemindersCount"]);
const { reminders, remindersLoading, remindersError } = useReminders(props.orderId);

watchEffect(() => {
  emit("updateRemindersCount", reminders.value?.length ?? 0);
});
</script>
<template>
<PrimeDataView v-if="!remindersLoading && !remindersError" :value="reminders" dataKey="name">
  <template #list="slotProps">
    <div class="">
      <div v-for="(item, index) in slotProps.items" :key="item.name">
        <ReminderItem :item="item" :index="index" />
      </div>
    </div>
  </template>
  <template #empty>
    <span>You have not updates at the moment</span>
  </template>
</PrimeDataView>
</template>
<style scoped>
a {
  --tw-text-opacity: 1;
  color: #007F80;
}
</style>
